import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingIndicator } from './layout/loading-indicator/loading-indicator';
import { InactivityTimeoutService } from './core/services/session/inactivity-timeout.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingIndicator],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly inactivityTimeout = inject(InactivityTimeoutService);
  protected readonly title = signal('Apex Habitat');

  ngOnInit(): void {
    this.inactivityTimeout.start();
  }

  ngOnDestroy(): void {
    this.inactivityTimeout.stop();
  }
}
